import { useRef } from 'react';

export const useScrollToSection = (config?: ScrollIntoViewOptions) => {
  const sectionRef = useRef(null);
  const handleScroll = (): void => {
    if (sectionRef.current) {
      sectionRef.current.scrollIntoView({ behavior: 'smooth', ...config });
    };
  };

  return { handleScroll, sectionRef };
};
